// Module
var code = "<svg width=\"11\" height=\"10\" viewBox=\"0 0 11 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0.999784 4.33333L4.33312 7.66667L9.88867 1\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n</svg>\n";
// Exports
export default code;